import { PropsWithChildren } from "react"
import { twMerge } from "tailwind-merge"

type CardProps = {
  className?: string
  dataTestId?: string
} & PropsWithChildren

export default function Card({ children, className, dataTestId }: CardProps) {
  return (
    <div
      className={twMerge("bg-white rounded-3xl p-8 ", className)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  )
}
